import { render, staticRenderFns } from "./DashboardButtons.vue?vue&type=template&id=62375ea2"
import script from "./DashboardButtons.vue?vue&type=script&lang=ts"
export * from "./DashboardButtons.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports